import React, { useState } from 'react'

import SyntaxHighlighter from 'react-syntax-highlighter'
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/hljs'

import extendedCodeExampleStyles from "./ExtendedCodeExample.module.css"

export default function ExtendedCodeExample({data, language}) {

    const CodeExample = ({title, request, response, message}) => {
        const [open, setOpen] = useState(false)

        return (
            <>
                { title && 
                    <div 
                        aria-expanded={open ? "true" : "false"}
                        className={open ? `${extendedCodeExampleStyles.expandableTitle} ${extendedCodeExampleStyles.active}` : extendedCodeExampleStyles.expandableTitle} 
                        onClick={() => setOpen(!open)}    
                        onKeyDown={() => setOpen(!open)}   
                        role="button" tabIndex="0"                   
                    >
                        { open ? "⊟" : "⊞" } {title}
                    </div> 
                }

                { open &&
                    <div className={extendedCodeExampleStyles.block}>
                        { request &&  
                            <div>
                                { request.title && 
                                    <div className={extendedCodeExampleStyles.blockTitle}>
                                        {request.title}
                                    </div> 
                                }
                                { request.code && 
                                    <SyntaxHighlighter language={language} style={dracula}>
                                        {request.code}
                                    </SyntaxHighlighter>                               
                                }                     
                            </div> 
                        }
                        
                        { response &&  
                            <div>
                                { response.title && 
                                    <div className={extendedCodeExampleStyles.blockTitle}>
                                        {response.title}
                                    </div> 
                                }
                                { response.code && 
                                    <SyntaxHighlighter language={language} style={dracula}>
                                        {response.code}
                                    </SyntaxHighlighter>                                 
                                }                     
                            </div> 
                        }

                        { message && <div className={extendedCodeExampleStyles.message}>{message}</div> }
                    </div>                    
                }

            </>
        )
    }

    const CodeExamples = ({ examples }) => {    
        return examples.map( ({title, request, response, message}, index) => (                    
            <div key={index}>
                <CodeExample 
                    title={title}
                    request={request}
                    response={response}
                    message={message}
                />
            </div>
        ))
    }

    return(       
        <div className={extendedCodeExampleStyles.container} >            
            { data && <CodeExamples examples={data}/> }            
        </div>   
    )
}

// "example_extended":{
//     "title": "Call sequence example",
//     "content":[
//         {
//             "title": "Step 1: get options from main upload endpoint",
//             "request":{
//                 "title":"Upload file using PATCH http method",
//                 "code":"some code"
//             },
//             "response":{
//                 "title":"Server returned Upload-Offset header",
//                 "code":"some code"
//             },
//             "message":"In the example above Upload-Offset response header value is equal to Content-Length which means upload is completed."
//         }
//     ]
// },